import React, { useContext, useEffect, useState } from 'react'
import "./IndicadoresNormas.scss"
import { NormasContext } from '../../context/NormasContext'
import { Oval } from 'react-loader-spinner'
import IllustrationAccess from "../../assets/img/access.png"
import ModalNewIndicador from '../Modales/Normas/ModalNewIndicador'
import ModalVerIndicador from '../Modales/Normas/ModalVerIndicador'
import ModalEditIndicador from '../Modales/Normas/ModalEditIndicador'
import { Modal } from 'react-bootstrap';
import "../Carrusel.scss"
// swiper
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

export const indicadoresNormasContext = React.createContext()

const IndicadoresNormas = ({ idProyecto, user }) => {

    const { status, indicadores, fetchIndicadoresNormas } = useContext(NormasContext)

    const [modalIndicador, setModalIndicador] = useState(false)
    const [objIndicador, setObjIndicador] = useState({})
    const [errorMetricas, setErrorMetricas] = useState(null)
    const [arrTresMetricas, setArrTresMetricas] = useState([])

    const [modalVerIndicador, setModalVerIndicador] = useState(false)

    const [idIndicador, setIdIndicador] = useState(null)
    const [objSeleccionado, setObjSeleccionado] = useState(null)
    const [modalEditInd, setModalEditInd] = useState(false)

    const [modalDeleteInd, setModalDeleteInd] = useState(false)
    const [errorDelete, setErrorDelete] = useState(null)

    useEffect(() => {
        if(idProyecto){
            fetchIndicadoresNormas({
                user,
                opcion: 2,
                idVista: parseInt(idProyecto)
            })
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idProyecto])

    const showIndicador = async (id) => {
        // obj del indicador seleccionado
        const ind = indicadores?.objeto.find(i => i.id_indicador === id)
        setObjIndicador(ind)
        // obtener últimas 3 métricas
        const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/dateIn/ultimas3Metricas`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                user,
                fkIndicador: id
            })
        })
        const data = await res.json()
        const errorCode = data.error ?? data.status
        if(errorCode !== 0){
            setErrorMetricas(data.errorDetalle || data.codeError)
        } else {
            const arr = data.objeto
            const opciones = { timeZone: "America/Argentina/Buenos_Aires", hour12: false, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit" };
            const newArr = arr.map((e) => {
                return {
                    ...e,
                    fecha_metrica: new Intl.DateTimeFormat("es-AR", opciones).format(new Date(e.fecha_metrica)) 
                }
            })
            setArrTresMetricas(newArr)
        }
        setModalVerIndicador(true)
    }

    // EDITAR INDICADOR
    const showEditIndicador = (id) => {
        const obj = indicadores?.objeto.find(i => i.id_indicador === id)
        setObjSeleccionado(JSON.stringify(obj))
        setModalEditInd(true)
    }

    // DELETE INDICADOR
    const showDeleteIndicador = (id) => {
        setIdIndicador(id)
        setModalDeleteInd(true)
    }

    const handleCloseDelete = () => {
        setModalDeleteInd(false)
        setErrorDelete(null)
    }

    const handleDeleteInd = async () => {
        try {
            // DELETE INDICADOR NORMAS ISO
            const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/dateIn/deleteIndicador`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    idIndicador,
                    user
                })
            })
            const data = await res.json()
            const errorCode = data.error ?? data.status;
            if(errorCode !== 0){
                setErrorDelete(data.errorDetalle || data.codeError)
            } else {
                handleCloseDelete()
                // actualizar indicadores
                fetchIndicadoresNormas({
                    user,
                    opcion: 2,
                    idVista: parseInt(idProyecto)
                })
            }
        } catch (error) {
            
        }
    }

    return (
        <>
            <indicadoresNormasContext.Provider value={{ user, idProyecto, objIndicador, setObjIndicador, errorMetricas, setErrorMetricas, arrTresMetricas, setArrTresMetricas, showIndicador, objSeleccionado, setObjSeleccionado }}>
                <ModalNewIndicador show={modalIndicador} onHide={()=>setModalIndicador(false)} animation={false} dialogClassName="custom-fade-modal" />
                <ModalVerIndicador show={modalVerIndicador} onHide={()=>setModalVerIndicador(false)} animation={false} dialogClassName="custom-fade-modal" />
                <ModalEditIndicador show={modalEditInd} onHide={()=>setModalEditInd(false)} animation={false} dialogClassName="custom-fade-modal" />
                {/* MODAL ELIMINAR INDICADOR */}
                <Modal className='modal__deleteIndicador' show={modalDeleteInd} onHide={()=>setModalDeleteInd(false)} backdrop="static" centered animation={false} >
                    <Modal.Header>
                        <Modal.Title className='d-flex flex-row'>
                            <h3 className='m-0'>Eliminar indicador</h3>
                            <button className='btn' onClick={handleCloseDelete}><i className="bi bi-x-lg fw-bold"></i></button>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>¿Está seguro de eliminar este indicador?</Modal.Body>
                    <Modal.Footer className='d-flex flex-column'>
                        {errorDelete !== null && 
                            <span className='modal__deleteIndicador--error align-self-center text-danger my-2'>
                                <i className="bi bi-exclamation-circle me-1"></i>{errorDelete}
                            </span>
                        }
                        <div className='d-flex flex-row align-items-center align-self-end'>
                            <button onClick={()=>setModalDeleteInd(false)} className='btn btn-secondary rounded-pill me-2'>Cancelar</button>
                            <button className='btn btn-danger rounded-pill' onClick={handleDeleteInd}>Borrar</button>
                        </div>
                    </Modal.Footer>
                </Modal>
                {/* LISTA INDICADORES */}
                <div className='indicadoresNormas'>
                    {status.indicadores.loading ? (
                        <div className='loading__indicadores d-flex flex-column align-items-center justify-content-center'>
                            <Oval
                                visible={true}
                                height="80"
                                width="80"
                                color="#0d6efd"
                                ariaLabel="oval-loading"
                                wrapperStyle={{}}
                                wrapperClass=""
                            />
                            <p className='fw-medium'>Loading...</p>
                        </div>
                    ) : (
                        <>
                            {status.indicadores.error ? (
                                <div className='indicadoresNormas--error d-flex flex-column align-items-center justify-content-center rounded-3'>
                                    <img className='mb-4' src={IllustrationAccess} alt="" />
                                    <h2 className='text-danger mb-1'>Oops!</h2>
                                    <p className='text-center'>{status.indicadores.error}</p>
                                </div>
                            ) : (
                                <>
                                    {indicadores?.objeto?.length === 0 ? (
                                        <div className='indicadoresNormas--empty d-flex flex-column align-items-center justify-content-center rounded-3'>
                                            <h3 className='text-blue-500 fw-semibold mb-1 text-center'>No tienes indicadores aún.</h3>
                                            {(user?.puesto === 1 || user?.puesto === 2 || user?.puesto === 3) && (
                                                <>
                                                    <p className='mb-3 text-center'>Para comenzar, crea tu primer indicador:</p>
                                                    <button className='btn btn-sm btn-primary rounded-pill shadow-sm fw-medium px-3' 
                                                        onClick={()=>setModalIndicador(true)}>
                                                        + agregar indicador
                                                    </button>
                                                </>
                                            )}
                                        </div>
                                    ) : (
                                        <div className='indicadoresNormas__main'>
                                            <div className='d-flex flex-row align-items-center justify-content-between mb-3'>
                                                <h4 className='fw-semibold text-blue-500 m-0'>Indicadores</h4>
                                                {(user?.puesto === 1 || user?.puesto === 2 || user?.puesto === 3) && (
                                                    <button 
                                                        onClick={()=>setModalIndicador(true)}
                                                        className='btn btn-sm btn-primary rounded-pill shadow-sm fw-medium px-3'>
                                                            + agregar indicador
                                                    </button>
                                                )}
                                            </div>
                                            <>
                                                {indicadores?.objeto?.length > 5 ? (
                                                    <div className='swiper-container items__container--carrusel h-100'>
                                                        <div className="swiper-button-prev"></div>
                                                        <div className="swiper-button-next"></div>
                                                        <Swiper
                                                            modules={[Navigation, Pagination, Scrollbar, A11y]}
                                                            spaceBetween={16} 
                                                            slidesPerView={1}
                                                            breakpoints={{
                                                                768: {slidesPerView: 2},
                                                                992: {slidesPerView: 5}
                                                            }}
                                                            navigation={{
                                                                prevEl: ".swiper-button-prev",
                                                                nextEl: ".swiper-button-next",
                                                            }}
                                                            pagination={{ el: ".swiper-pagination-area", clickable: true }}
                                                        >
                                                            {indicadores?.objeto?.map((indicador, i) => {
                                                                return <SwiperSlide key={i} className='item__container item--carrusel h-100'>
                                                                    <div className='eachIndicador w-100 h-100 border border-1 border-light-subtle shadow-sm rounded-3'>
                                                                        <div className='h-100 d-flex flex-column justify-content-between m-0' onClick={()=>showIndicador(indicador.id_indicador)}>
                                                                            <div className='titulo p-3'>
                                                                                <h4 className='fw-semibold m-0' style={{color:indicador.color[0]}}>{indicador.nombre_indicador}</h4>
                                                                            </div>
                                                                            <div className='detalles px-3 py-2 rounded-bottom d-flex flex-row align-items-center justify-content-between gap-2' style={{backgroundColor:indicador.color[0]}}>
                                                                                <p className='text-empleado m-0 text-white fw-semibold'>{indicador.Empleados[0]?.nombre}</p>
                                                                                <div className='d-flex flex-row align-items-center'>
                                                                                    <p className='m-0 text-white'>{indicador.fecha_del_recodatorio?.replace(/-/g, '/').split("/").reverse().join("/")}</p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        {(user?.puesto === 1 || user?.puesto === 2 || user?.puesto === 3) && (
                                                                            <div className='buttons p-3 active'>
                                                                                <button onClick={()=>showEditIndicador(indicador.id_indicador)} className='btn bg-success rounded-circle me-2 text-white'><i className="bi bi-pencil text-white"></i></button>
                                                                                <button onClick={()=>showDeleteIndicador(indicador.id_indicador)} className='btn bg-danger rounded-circle text-white'><i className="bi bi-trash3 text-white"></i></button>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </SwiperSlide>
                                                            })}
                                                        </Swiper>
                                                        <div className="swiper-pagination-area"></div>
                                                    </div>
                                                ) : (
                                                    <div className='indicadoresNormas__main__lista'>
                                                        {indicadores?.objeto?.map((indicador, i) => (
                                                            <div key={i} className='eachIndicador h-100 border border-1 border-light-subtle shadow-sm rounded-3'>
                                                                <div className='h-100 d-flex flex-column justify-content-between m-0' onClick={()=>showIndicador(indicador.id_indicador)}>
                                                                    <div className='titulo p-3'>
                                                                        <h4 className='fw-semibold m-0' style={{color:indicador.color[0]}}>{indicador.nombre_indicador}</h4>
                                                                    </div>
                                                                    <div className='detalles px-3 py-2 rounded-bottom d-flex flex-row align-items-center justify-content-between gap-2' style={{backgroundColor:indicador.color[0]}}>
                                                                        <p className='text-empleado m-0 text-white fw-semibold'>{indicador.Empleados[0]?.nombre}</p>
                                                                        <div className='d-flex flex-row align-items-center'>
                                                                            <p className='m-0 text-white'>{indicador.fecha_del_recodatorio?.replace(/-/g, '/').split("/").reverse().join("/")}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {(user?.puesto === 1 || user?.puesto === 2 || user?.puesto === 3) && (
                                                                    <div className='buttons p-3 active'>
                                                                        <button onClick={()=>showEditIndicador(indicador.id_indicador)} className='btn bg-success rounded-circle me-2 text-white'><i className="bi bi-pencil text-white"></i></button>
                                                                        <button onClick={()=>showDeleteIndicador(indicador.id_indicador)} className='btn bg-danger rounded-circle text-white'><i className="bi bi-trash3 text-white"></i></button>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </>
                                        </div>
                                    )}
                                </>
                            )}
                        </>
                    )}
                </div>
            </indicadoresNormasContext.Provider>
        </>
    )
}

export default IndicadoresNormas